import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../services/i18nService';
import { getA11yAttributesV7 } from '../../../../services/a11yIIBScreenReaderService';
import styles from '../../testOverview.scss';

import liveSessioner from '../../../../services/livesession/LiveSessioner';
import ConfirmHardwareSettingsContainer from './ConfirmHardwareSettings';
import ExitTestButton from './../../ExitTestButton';
import GrantHardwareAccessButton from './GrantHardwareAccessButton';

class TestComponentHardwareAccessCheck extends React.PureComponent {
    static propTypes = {
        offerGrantAccess: PropTypes.bool.isRequired,
        offerRetryRequestAccess: PropTypes.bool.isRequired,
        offerSwitchDevice: PropTypes.bool.isRequired,
        statusDescription: PropTypes.string,
    };

    handleRetryRequestAccess = () => {
        liveSessioner.requestHardwareAccess();
    }

    render() {
        const {
            offerGrantAccess,
            offerRetryRequestAccess,
            offerSwitchDevice,
            statusDescription,
        } = this.props;

        return (
            <React.Fragment>
                { statusDescription &&
                    // The description is only rendered once hardware access has been
                    // rejected, so announcing it on insert reports the rejection to
                    // screen reader users who are not looking at the step.
                    <div
                        className={styles.hardwareDescription}
                        {...getA11yAttributesV7({ role: 'alert' })}
                    >
                        {statusDescription}
                    </div>
                }

                { offerGrantAccess && <GrantHardwareAccessButton /> }

                { offerSwitchDevice && <ConfirmHardwareSettingsContainer /> }

                { offerRetryRequestAccess &&
                    <div>
                        <button className={`${styles.button} btn`} onClick={this.handleRetryRequestAccess} >
                            {t('hardwareAccessCheck.retryHardwareSettings')}
                        </button>
                        <span className={styles.orSeparator}>{t('general.or')}</span>
                        <ExitTestButton showButtonForNonLockdown />
                    </div>
                }
            </React.Fragment>
        );
    }
}

export default TestComponentHardwareAccessCheck;
